import Vue from 'vue';
import Router from 'vue-router';
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

//这是写路由的地方，在page中 新建一个vue（需要页面之间进行跳转的）就在这个里面写路由。
const routes = [{
    path: "/", //首页
    name: "index",
    component: () => import('@/page/index/index'),
  },
  {
    path: "/saishi", //赛事
    name: "saishi",
    component: () => import('@/page/index/saishi'),
  },
  {
    path: "/zuopin", //作品
    name: "zuopin",
    component: () => import('@/page/index/zuopin'),
  },
  {
    path: "/gongshi", //获奖公示
    name: "gongshi",
    component: () => import('@/page/index/gongshi'),
  }
];
const VueRouter = new Router({
  routes
});

export default VueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js